import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-US').format(value)
}

export function formatPercentage(value: number): string {
  return `${(value * 100).toFixed(2)}%`
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date))
}

export function getRiskColor(score: number, maxScore = 5): string {
  const ratio = score / maxScore
  if (ratio >= 0.8) return 'text-risk-excellent'
  if (ratio >= 0.6) return 'text-risk-good'
  if (ratio >= 0.4) return 'text-risk-fair'
  if (ratio >= 0.2) return 'text-risk-poor'
  return 'text-risk-critical'
}

export function getRiskBgColor(score: number, maxScore = 5): string {
  const ratio = score / maxScore
  if (ratio >= 0.8) return 'bg-risk-excellent'
  if (ratio >= 0.6) return 'bg-risk-good'
  if (ratio >= 0.4) return 'bg-risk-fair'
  if (ratio >= 0.2) return 'bg-risk-poor'
  return 'bg-risk-critical'
}

export function getRiskLabel(category: string): { label: string; color: string } {
  const mapping: Record<string, { label: string; color: string }> = {
    'Low Risk 1': { label: 'Excellent', color: 'bg-risk-excellent' },
    'Low Risk 2': { label: 'Very Good', color: 'bg-risk-good' },
    'Medium Risk 1': { label: 'Good', color: 'bg-risk-good' },
    'Medium Risk 2': { label: 'Fair', color: 'bg-risk-fair' },
    'High Risk 1': { label: 'Poor', color: 'bg-risk-poor' },
    'High Risk 2': { label: 'Critical', color: 'bg-risk-critical' },
  }
  return mapping[category] || { label: category, color: 'bg-gray-400' }
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}
